/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Live_Implausible_Reps_TitleInputs */

const en_us2_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Did you really do ${i?.count} reps?`)
};

const pt_br2_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você fez mesmo ${i?.count} repetições?`)
};

const es_419_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿De verdad hiciste ${i?.count} repeticiones?`)
};

const pt_pt2_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fizeste mesmo ${i?.count} repetições?`)
};

const fr_fr2_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as vraiment fait ${i?.count} répétitions ?`)
};

const de_de2_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wirklich ${i?.count} Wiederholungen?`)
};

const it_it2_workout_live_implausible_reps_title = /** @type {(inputs: Workout_Live_Implausible_Reps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai fatto davvero ${i?.count} ripetizioni?`)
};

/**
* | output |
* | --- |
* | "Did you really do {count} reps?" |
*
* @param {Workout_Live_Implausible_Reps_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_reps_title = /** @type {((inputs: Workout_Live_Implausible_Reps_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_Reps_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_reps_title(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_reps_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_reps_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_reps_title(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_reps_title(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_reps_title(inputs)
	return en_us2_workout_live_implausible_reps_title(inputs)
});
export { workout_live_implausible_reps_title as "workout-live.implausible_reps_title" }